// TaxRateForm Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import FormButton from '../../../common/form/button/button.jsx'
import Input from '../../../common/form/input/input.jsx'
import InputTax from '../../../common/form/input_tax/input_tax.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'

class TaxRateForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dataDate: null
    }

    this.data = {
      taxRates: props.taxRates ? props.taxRates : []
    }
  }

  static get propTypes () {
    return {
      taxRates: PropTypes.array,
      onSubmit: PropTypes.func,
      onError: PropTypes.func,
      prefixCurrency: PropTypes.string,
      title: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      taxRates: [],
      onSubmit: null,
      onError: null,
      prefixCurrency: '',
      title: ''
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!_.isEqual(nextProps.taxRates, this.data.taxRates)) {
      this.data.taxRates = nextProps.taxRates
      this.setState({ dataDate: new Date() })
    }
  }

  render () {
    const title = this.props.title ? `${this.props.title} ` : ''
    return (
      <div className='taxrate-form'>
        <form
          className='taxform'
          method='post'
          noValidate
          action='#'
          onSubmit={this._onFormSubmit.bind(this)}
        >
          <div className='form-layout'>
            <div className='layoutcol'>
              <div className='formsection'>
                <div className='headertitle'>
                  {title}
                  <IntlMessage ident='setting.taxRate.taxFormTitle' />
                </div>
                {this._renderTaxRates()}
                <FormButton
                  title='setting.taxRate.actionAddTaxRateItem'
                  secondary
                  onClick={this._onAddTaxRate.bind(this)}
                />
              </div>
            </div>
          </div>
          <IconButton
            icon='common-success-tick'
            title='setting.taxRate.tipSave'
            type='primary'
            size='big'
            canHover={false}
            tooltip='setting.taxRate.tipSave'
            tooltipPosition='top'
            className='wizard-submit'
            onClick={this._onFormSubmit.bind(this)}
          />
        </form>
      </div>
    )
  }

  /* Event Handlers */
  _onChangeTaxRate (name, idx, value) {
    if (this.data.taxRates[idx]) {
      if (name === 'isService') {
        this.data.taxRates[idx].isProduct = false
        this.data.taxRates[idx].isService = value
      } else if (name === 'isProduct') {
        this.data.taxRates[idx].isProduct = value
        this.data.taxRates[idx].isService = false
      } else {
        this.data.taxRates[idx][name] = value
      }
    }

    this._refresh()
  }

  _onRemoveTaxRate (idx, _e) {
    if (this.data.taxRates[idx]) {
      this.data.taxRates.splice(idx, 1)
    }

    this._refresh()
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  /* Private Function */
  _renderTaxRates () {
    if (this.data.taxRates && this.data.taxRates.length > 0) {
      return this.data.taxRates.map((taxRateObj, idx) => (
        <div className='formrow formrow__secondary' key={idx}>
          <div className='formcol2'>
            <Input
              type='text'
              name='title'
              size={10}
              maxLength={100}
              label='setting.taxRate.titlePlaceholder'
              value={taxRateObj.title}
              styleDotted
              prefixCustom
              onClickPrefix={this._onRemoveTaxRate.bind(this, idx)}
              onChange={this._onChangeTaxRate.bind(this, 'title', idx)}
              onKeyDown={this._onNameKeyDown.bind(this, idx)}
              tabIndex={idx * 100 + 1}
              prefixIcon='form-input-delete'
            />
            <div className='checkfields'>
              <span className='label'>
                <IntlMessage ident='setting.taxRate.defaultLabel' />
              </span>
              <Checkbox
                label='setting.taxRate.serviceCheckField'
                checked={taxRateObj.isService}
                icon='common'
                onChange={this._onChangeTaxRate.bind(this, 'isService', idx)}
              />
              <Checkbox
                label='setting.taxRate.productCheckField'
                checked={taxRateObj.isProduct}
                icon='common'
                onChange={this._onChangeTaxRate.bind(this, 'isProduct', idx)}
              />
            </div>
          </div>
          <div className='formcol2'>
            <InputTax
              type='text'
              name='percentage'
              maxLength={120}
              label='setting.taxRate.percentagePlaceholder'
              size={10}
              tabIndex={idx * 100 + 2}
              required
              styleDotted
              validations={['required']}
              value={taxRateObj.percentage}
              onChange={this._onChangeTaxRate.bind(this, 'percentage', idx)}
              onKeyDown={this._onRateKeyDown.bind(this, idx)}
            />
          </div>
        </div>
      ))
    }

    return ''
  }

  _onFormSubmit (ev) {
    ev.preventDefault()

    const rates = _.cloneDeep(this.data.taxRates)
    _.remove(rates, (rateObj, _objIdx) => {
      if (rateObj.title === '' || rateObj.percentage === '') {
        return true
      }
    })

    if (this.props.onSubmit) {
      this.props.onSubmit(rates)
    }
  }

  _onAddTaxRate (ev) {
    ev.preventDefault()

    this.data.taxRates.push({
      title: '',
      percentage: 0,
      isProduct: false,
      isService: false
    })
    this._refresh()
  }

  _processEnterKeyDown (idx, ev) {
    if (ev.keyCode === 13) {
      // If enter key on last row, add new row
      if (this.data.taxRates.length === idx + 1) {
        this.data.taxRates.push({
          title: '',
          percentage: 0,
          isProduct: false,
          isService: false
        })
        this._refresh()

        ev.preventDefault()
        ev.stopPropagation()
      } else {
        this._onFormSubmit(ev)
      }
    }
  }

  _onNameKeyDown (idx, ev) {
    this._processEnterKeyDown(idx, ev)
  }

  _onRateKeyDown (idx, ev) {
    this._processEnterKeyDown(idx, ev)

    if (ev.keyCode === 9) {
      if (this.data.taxRates.length === idx + 1) {
        this.data.taxRates.push({
          title: '',
          percentage: 0,
          isProduct: false,
          isService: false
        })
        this._refresh()
      }
    }
  }
}

export default TaxRateForm
